import {
  parseAsSingleDateFilter,
  SingleDateFilterValue,
} from '@app/core/list-view/helpers/parse-as-single-date-filter';

/** Route helpers for the YouTube broadcasts list page. */
export const youtubeBroadcastsListRouteGenerator = {
  list: (stationSlug: string, targetDate?: SingleDateFilterValue | null) => {
    const basePath = `/youtube-broadcasts/s/${stationSlug}`;

    if (!targetDate) {
      return basePath;
    }

    const serializedTargetDate = parseAsSingleDateFilter.serialize(targetDate);

    if (!serializedTargetDate) {
      return basePath;
    }

    return `${basePath}?targetDate=${encodeURIComponent(serializedTargetDate)}`;
  },
};
